import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Redirect, Route } from 'react-router-dom';
import { isAuthorized } from '../app/userImpersonate';

function PrivateRoute({ component: Component, roles, ...rest }) {
  const keycloakObject = useKeycloak();

  return (
    <Route
      {...rest}
      render={props => {
        return isAuthorized(keycloakObject, roles)
          ? <Component {...props} />
          : <Redirect to="/" />
      }}
    />
  );
}

export default PrivateRoute;
